import { text } from '@modules/sign-up/text';
import { useAuthActions } from '@convex-dev/auth/react';
import { getSignUpErrorMessage } from '@modules/sign-up/business_logic';
import { useSignUpStore } from '@shared/store/useSignUpStore';

export function useSignUpSubmit(
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  onSuccessNavigate: () => void
) {
  const { signIn } = useAuthActions();
  const form = useSignUpStore((s) => s.form);
  const setIsSubmitting = useSignUpStore((s) => s.setIsSubmitting);
  const reset = useSignUpStore((s) => s.reset);

  return () => {
    if (!form.email || !form.password) return;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('password', form.password);
    formData.append('flow', 'signUp');

    signIn('password', formData)
      .then(() => {
        onSuccess(text.success);
        reset();
        onSuccessNavigate();
      })
      .catch((error: Error) => {
        onError(getSignUpErrorMessage(error));
        setIsSubmitting(false);
      });
  };
}
